// Translations for Bistró Pont10
export const translations = {
  es: {
    welcome: 'Bienvenido',
    tagline: 'El sabor de lo nuestro',
    selectLanguage: 'Selecciona tu idioma',
    bar: 'Bar',
    barDesc: 'Experiencia líquida',
    cafe: 'Cafetería',
    cafeDesc: 'Momentos cálidos',
    tasting: 'Degustación',
    tastingDesc: 'Sabores de proximidad',
    back: 'Volver',
    alsoLike: 'Ideal para acompañar',
    price: 'Precio',
    options: 'Personaliza tu elección',
    supplements: 'Añade un extra',
    vegan: 'Vegano',
    glutenFree: 'Sin gluten',
    local: 'Local',
    doEmporda: 'DO Empordà',
    premium: 'Selección Auténtica',
    categories: 'Categorías',
    products: 'Productos',
    admin: 'Administración',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    username: 'Usuario',
    password: 'Contraseña',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    name: 'Nombre',
    description: 'Descripción',
    image: 'Imagen',
    active: 'Activo',
    inactive: 'Inactivo',
    order: 'Orden',
    search: 'Buscar',
    noResults: 'No hay resultados',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    confirm: 'Confirmar',
    all: 'Todos',
    explore: 'Explora',
    discover: 'Descubre',
    add: 'Añadir',
    added: '¡Añadido!',
    close: 'Cerrar',
  },
  en: {
    welcome: 'Welcome',
    tagline: 'The taste of our land',
    selectLanguage: 'Select your language',
    bar: 'Bar',
    barDesc: 'Liquid experience',
    cafe: 'Cafetería',
    cafeDesc: 'Warm moments',
    tasting: 'Tasting',
    tastingDesc: 'Local flavors',
    back: 'Back',
    alsoLike: 'Perfect to pair with',
    price: 'Price',
    options: 'Customize your choice',
    supplements: 'Add an extra',
    vegan: 'Vegan',
    glutenFree: 'Gluten Free',
    local: 'Local',
    doEmporda: 'DO Empordà',
    premium: 'Authentic Selection',
    categories: 'Categories',
    products: 'Products',
    admin: 'Administration',
    login: 'Login',
    logout: 'Logout',
    username: 'Username',
    password: 'Password',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    name: 'Name',
    description: 'Description',
    image: 'Image',
    active: 'Active',
    inactive: 'Inactive',
    order: 'Order',
    search: 'Search',
    noResults: 'No results',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    all: 'All',
    explore: 'Explore',
    discover: 'Discover',
    add: 'Add',
    added: 'Added!',
    close: 'Close',
  },
  cat: {
    welcome: 'Benvingut',
    tagline: 'El sabor del nostre',
    selectLanguage: 'Selecciona el teu idioma',
    bar: 'Bar',
    barDesc: 'Experiència líquida',
    cafe: 'Cafè',
    cafeDesc: 'Moments càlids',
    tasting: 'Degustació',
    tastingDesc: 'Sabors de proximitat',
    back: 'Tornar',
    alsoLike: 'Ideal per acompanyar',
    price: 'Preu',
    options: 'Personalitza la teva elecció',
    supplements: 'Afegeix un extra',
    vegan: 'Vegà',
    glutenFree: 'Sense gluten',
    local: 'Local',
    doEmporda: 'DO Empordà',
    premium: 'Selecció Autèntica',
    categories: 'Categories',
    products: 'Productes',
    admin: 'Administració',
    login: 'Iniciar sessió',
    logout: 'Tancar sessió',
    username: 'Usuari',
    password: 'Contrasenya',
    save: 'Desar',
    cancel: 'Cancel·lar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    name: 'Nom',
    description: 'Descripció',
    image: 'Imatge',
    active: 'Actiu',
    inactive: 'Inactiu',
    order: 'Ordre',
    search: 'Cercar',
    noResults: 'No hi ha resultats',
    loading: 'Carregant...',
    error: 'Error',
    success: 'Èxit',
    confirm: 'Confirmar',
    all: 'Tots',
    explore: 'Explora',
    discover: 'Descobreix',
    add: 'Afegir',
    added: 'Afegit!',
    close: 'Tancar',
  },
  fr: {
    welcome: 'Bienvenue',
    tagline: 'La saveur de notre terroir',
    selectLanguage: 'Sélectionnez votre langue',
    bar: 'Bar',
    barDesc: 'Expérience liquide',
    cafe: 'Cafetería',
    cafeDesc: 'Moments chaleureux',
    tasting: 'Dégustation',
    tastingDesc: 'Saveurs de proximité',
    back: 'Retour',
    alsoLike: 'Idéal pour accompagner',
    price: 'Prix',
    options: 'Personnalisez votre choix',
    supplements: 'Ajoutez un extra',
    vegan: 'Végétalien',
    glutenFree: 'Sans gluten',
    local: 'Local',
    doEmporda: 'DO Empordà',
    premium: 'Sélection Authentique',
    categories: 'Catégories',
    products: 'Produits',
    admin: 'Administration',
    login: 'Connexion',
    logout: 'Déconnexion',
    username: 'Utilisateur',
    password: 'Mot de passe',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    create: 'Créer',
    name: 'Nom',
    description: 'Description',
    image: 'Image',
    active: 'Actif',
    inactive: 'Inactif',
    order: 'Commander',
    search: 'Rechercher',
    noResults: 'Aucun résultat',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    confirm: 'Confirmer',
    all: 'Tous',
    explore: 'Explorer',
    discover: 'Découvrir',
    add: 'Ajouter',
    added: 'Ajouté !',
    close: 'Fermer',
  },
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.es[key] || key;
};

export const getLocalizedField = (obj, lang) => {
  if (!obj) return '';
  if (typeof obj === 'string') return obj;
  return obj[lang] || obj.es || obj.en || '';
};
